import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const API = 'https://csksportswear.in/backend/api';

function Dashboard() {
  const [stats, setStats] = useState({});
  const [recentBills, setRecentBills] = useState([]);
  const [lowStock, setLowStock] = useState([]);
  const [newEnquiries, setNewEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('csk_user') || '{}');

  useEffect(() => {
    const tok = localStorage.getItem('csk_token');
    if (!tok) { navigate('/login'); return; }
    fetchAll(tok);
  }, []);

  const fetchAll = async (tok) => {
    try {
      const headers = { Authorization: `Bearer ${tok}` };
      const [statsRes, billsRes, stockRes, enquiriesRes] = await Promise.all([
        axios.get(`${API}/inventory.php?action=summary`, { headers }),
        axios.get(`${API}/bills.php?action=list`, { headers }),
        axios.get(`${API}/inventory.php?action=low_stock`, { headers }),
        axios.get(`${API}/enquiries.php?action=list`, { headers }),
      ]);

      if (statsRes.data.success) setStats(statsRes.data.data);
      if (billsRes.data.success) setRecentBills(billsRes.data.data.slice(0, 5));
      if (stockRes.data.success) setLowStock(stockRes.data.data.slice(0, 5));
      if (enquiriesRes.data.success) {
        const newEnq = enquiriesRes.data.data.filter(e => e.status === 'new');
        setNewEnquiries(newEnq.slice(0, 5));
      }
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  // Today's bills
  const today = new Date().toDateString();
  const todayBills = recentBills.filter(b => new Date(b.created_at).toDateString() === today);
  const todayRevenue = todayBills.reduce((sum, b) => sum + parseFloat(b.total || 0), 0);

  const formatTime = (dateStr) => new Date(dateStr).toLocaleTimeString('en-IN', {
    hour: '2-digit', minute: '2-digit', hour12: true
  });

  const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric'
  });

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: '🏠' },
    { path: '/admin/inventory', label: 'Inventory', icon: '📦' },
    ...(user.role === 'admin' ? [{ path: '/admin/pos', label: 'POS Billing', icon: '🧾' }] : []),
    { path: '/admin/reports', label: 'Reports', icon: '📊' },
    { path: '/admin/gallery', label: 'Gallery', icon: '🖼️' },
    { path: '/admin/enquiries', label: 'Enquiries', icon: '📩' },
    ...(user.role === 'admin' ? [
      { path: '/admin/settings', label: 'Settings', icon: '⚙️' },
      { path: '/admin/users', label: 'Users', icon: '👥' },
    ] : []),
  ];

  const newEnqCount = newEnquiries.length;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0A0A0A', fontFamily: 'Inter, sans-serif' }}>
      <style>{`
        .dash-sidebar { width: 200px; background: #000; border-right: 1px solid rgba(255,255,255,0.08); display: flex; flex-direction: column; position: fixed; top: 0; left: 0; bottom: 0; z-index: 100; transition: transform 0.3s ease; }
        .dash-main { margin-left: 200px; flex: 1; padding: 32px; }
        .dash-mobile-hdr { display: none; background: #000; padding: 12px 16px; position: fixed; top: 0; left: 0; right: 0; z-index: 99; border-bottom: 1px solid rgba(255,255,255,0.08); align-items: center; justify-content: space-between; }
        .dash-overlay { display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.7); z-index: 99; }
        @media (max-width: 768px) {
          .dash-sidebar { transform: translateX(-100%); }
          .dash-sidebar.open { transform: translateX(0); }
          .dash-main { margin-left: 0; padding: 72px 16px 16px; }
          .dash-mobile-hdr { display: flex; }
          .dash-overlay.show { display: block; }
          .dash-stats { grid-template-columns: repeat(2, 1fr) !important; }
          .dash-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 480px) {
          .dash-stats { grid-template-columns: 1fr 1fr !important; }
        }
        .dash-nav-link { display: flex; align-items: center; gap: 10px; padding: 12px 16px; color: #475569; font-size: 13px; font-weight: 500; text-decoration: none; border-left: 3px solid transparent; transition: all 0.2s; }
        .dash-nav-link:hover { color: white; background: rgba(255,255,255,0.05); }
        .dash-nav-link.active { color: white; background: rgba(0,102,255,0.1); border-left-color: #0066FF; }
        .stat-card { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 20px; transition: all 0.3s; }
        .stat-card:hover { border-color: rgba(0,102,255,0.2); transform: translateY(-2px); }
        .widget { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; overflow: hidden; }
        .widget-header { padding: 16px 20px; border-bottom: 1px solid rgba(255,255,255,0.08); display: flex; justify-content: space-between; align-items: center; }
        .quick-btn { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px; padding: 20px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; cursor: pointer; transition: all 0.2s; text-decoration: none; color: white; }
        .quick-btn:hover { border-color: rgba(0,102,255,0.3); background: rgba(0,102,255,0.05); }
      `}</style>

      {/* Mobile Header */}
      <div className="dash-mobile-hdr">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ color: '#DC2626', fontSize: '20px' }}>★</span>
          <span style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 800, color: 'white' }}>CSK</span>
        </div>
        <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '22px', cursor: 'pointer' }}>☰</button>
      </div>

      <div className={`dash-overlay ${sidebarOpen ? 'show' : ''}`} onClick={() => setSidebarOpen(false)} />

      {/* Sidebar */}
      <div className={`dash-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div style={{ padding: '16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#DC2626', fontSize: '20px' }}>★</span>
            <div>
              <div style={{ fontFamily: 'Montserrat', fontSize: '13px', fontWeight: 800, letterSpacing: '2px', color: 'white' }}>CSK</div>
              <div style={{ fontSize: '8px', color: '#475569', letterSpacing: '1px' }}>ADMIN PANEL</div>
            </div>
          </div>
        </div>
        <div style={{ padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: '13px', fontWeight: 600, color: 'white' }}>{user.name}</div>
          <div style={{ fontSize: '11px', color: '#0066FF', textTransform: 'uppercase', letterSpacing: '1px' }}>{user.role}</div>
        </div>
        <nav style={{ flex: 1, padding: '8px 0', overflowY: 'auto' }}>
          {menuItems.map(item => (
            <Link key={item.path} to={item.path}
              className={`dash-nav-link ${window.location.pathname === item.path ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}>
              <span>{item.icon}</span>
              {item.label}
              {item.path === '/admin/enquiries' && newEnqCount > 0 && (
                <span style={{ marginLeft: 'auto', background: '#DC2626', color: 'white', borderRadius: '50%', width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700 }}>{newEnqCount}</span>
              )}
            </Link>
          ))}
        </nav>
        <div style={{ padding: '12px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <button onClick={() => { localStorage.clear(); navigate('/login'); }} style={{ width: '100%', padding: '8px', background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '6px', color: '#DC2626', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>🚪 Logout</button>
        </div>
      </div>

      {/* Main */}
      <div className="dash-main">
        {/* Header */}
        <div style={{ marginBottom: '28px' }}>
          <h1 style={{ fontFamily: 'Montserrat', fontSize: '28px', fontWeight: 800, color: 'white', marginBottom: '4px' }}>
            Dashboard
          </h1>
          <p style={{ color: '#475569', fontSize: '14px' }}>
            Welcome back, <span style={{ color: '#0066FF', fontWeight: 600 }}>{user.name}</span>! — {new Date().toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', color: '#475569', padding: '60px' }}>Loading...</div>
        ) : (
          <>
            {/* Stats Cards */}
            <div className="dash-stats" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
              {[
                { label: "Today's Bills", value: todayBills.length, icon: '🧾', color: '#0066FF', sub: 'bills today' },
                { label: "Today's Revenue", value: '₹' + todayRevenue.toFixed(0), icon: '💰', color: '#16A34A', sub: 'earned today' },
                { label: 'Total Products', value: stats.total_products || 0, icon: '📦', color: '#F59E0B', sub: 'in inventory' },
                { label: 'New Enquiries', value: newEnqCount, icon: '📩', color: '#DC2626', sub: 'unread messages' },
              ].map((s, i) => (
                <div key={i} className="stat-card">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <div style={{ fontSize: '11px', color: '#475569', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>{s.label}</div>
                      <div style={{ fontFamily: 'Montserrat', fontSize: '28px', fontWeight: 900, color: s.color, marginBottom: '4px' }}>{s.value}</div>
                      <div style={{ fontSize: '11px', color: '#475569' }}>{s.sub}</div>
                    </div>
                    <div style={{ width: '44px', height: '44px', background: `rgba(${s.color === '#0066FF' ? '0,102,255' : s.color === '#16A34A' ? '22,163,74' : s.color === '#F59E0B' ? '245,158,11' : '220,38,38'},0.1)`, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px' }}>
                      {s.icon}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Second Row Stats */}
            <div className="dash-stats" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
              {[
                { label: 'Total Revenue', value: '₹' + parseFloat(stats.total_revenue || 0).toFixed(0), icon: '📈', color: '#8B5CF6', sub: 'all time' },
                { label: 'Total Bills', value: stats.total_bills || 0, icon: '🧾', color: '#0066FF', sub: 'all time' },
                { label: 'Low Stock', value: stats.low_stock || 0, icon: '⚠️', color: '#F59E0B', sub: 'need restock' },
                { label: 'Stock Value', value: '₹' + parseFloat(stats.total_value || 0).toFixed(0), icon: '💎', color: '#16A34A', sub: 'inventory worth' },
              ].map((s, i) => (
                <div key={i} className="stat-card">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <div style={{ fontSize: '11px', color: '#475569', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>{s.label}</div>
                      <div style={{ fontFamily: 'Montserrat', fontSize: '28px', fontWeight: 900, color: s.color, marginBottom: '4px' }}>{s.value}</div>
                      <div style={{ fontSize: '11px', color: '#475569' }}>{s.sub}</div>
                    </div>
                    <div style={{ width: '44px', height: '44px', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px' }}>
                      {s.icon}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Quick Actions */}
            <div style={{ marginBottom: '24px' }}>
              <h3 style={{ fontFamily: 'Montserrat', fontSize: '16px', fontWeight: 700, color: 'white', marginBottom: '16px' }}>Quick Actions</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px' }}>
                {[
                  ...(user.role === 'admin' ? [{ path: '/admin/pos', icon: '🧾', label: 'New Bill', color: '#0066FF' }] : []),
                  { path: '/admin/inventory', icon: '📦', label: 'Add Product', color: '#16A34A' },
                  { path: '/admin/enquiries', icon: '📩', label: 'View Enquiries', color: '#DC2626', badge: newEnqCount },
                  { path: '/admin/reports', icon: '📊', label: 'Reports', color: '#F59E0B' },
                  { path: '/admin/gallery', icon: '🖼️', label: 'Gallery', color: '#8B5CF6' },
                  ...(user.role === 'admin' ? [{ path: '/admin/settings', icon: '⚙️', label: 'Settings', color: '#475569' }] : []),
                ].map((item, i) => (
                  <Link key={i} to={item.path} className="quick-btn">
                    <div style={{ position: 'relative' }}>
                      <div style={{ fontSize: '28px' }}>{item.icon}</div>
                      {item.badge > 0 && (
                        <span style={{ position: 'absolute', top: '-4px', right: '-8px', background: '#DC2626', color: 'white', borderRadius: '50%', width: '16px', height: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px', fontWeight: 700 }}>{item.badge}</span>
                      )}
                    </div>
                    <span style={{ fontSize: '12px', fontWeight: 600, color: '#94A3B8' }}>{item.label}</span>
                  </Link>
                ))}
              </div>
            </div>

            {/* Widgets Grid */}
            <div className="dash-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '24px' }}>

              {/* Recent Bills */}
              <div className="widget">
                <div className="widget-header">
                  <h3 style={{ fontFamily: 'Montserrat', fontSize: '15px', fontWeight: 700, color: 'white' }}>🧾 Recent Bills</h3>
                  <Link to="/admin/reports" style={{ fontSize: '12px', color: '#0066FF', textDecoration: 'none', fontWeight: 600 }}>View All →</Link>
                </div>
                {recentBills.length === 0 ? (
                  <div style={{ padding: '32px', textAlign: 'center', color: '#475569' }}>No bills yet</div>
                ) : (
                  <div>
                    {recentBills.map(bill => (
                      <div key={bill.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 20px', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                        <div>
                          <div style={{ fontSize: '13px', fontWeight: 600, color: '#0066FF' }}>{bill.bill_number}</div>
                          <div style={{ fontSize: '11px', color: '#475569', marginTop: '2px' }}>{formatTime(bill.created_at)}</div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ fontSize: '14px', fontWeight: 700, color: '#16A34A' }}>₹{parseFloat(bill.total || 0).toFixed(0)}</div>
                          <span style={{ fontSize: '10px', fontWeight: 600, textTransform: 'uppercase', padding: '2px 8px', borderRadius: '50px', background: bill.payment_method === 'cash' ? 'rgba(22,163,74,0.1)' : bill.payment_method === 'upi' ? 'rgba(0,102,255,0.1)' : 'rgba(139,92,246,0.1)', color: bill.payment_method === 'cash' ? '#16A34A' : bill.payment_method === 'upi' ? '#0066FF' : '#8B5CF6' }}>
                            {bill.payment_method}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* New Enquiries */}
              <div className="widget">
                <div className="widget-header">
                  <h3 style={{ fontFamily: 'Montserrat', fontSize: '15px', fontWeight: 700, color: 'white' }}>
                    📩 New Enquiries
                    {newEnqCount > 0 && <span style={{ marginLeft: '8px', background: '#DC2626', color: 'white', borderRadius: '50px', padding: '1px 8px', fontSize: '11px' }}>{newEnqCount}</span>}
                  </h3>
                  <Link to="/admin/enquiries" style={{ fontSize: '12px', color: '#0066FF', textDecoration: 'none', fontWeight: 600 }}>View All →</Link>
                </div>
                {newEnquiries.length === 0 ? (
                  <div style={{ padding: '32px', textAlign: 'center', color: '#475569' }}>
                    <div style={{ fontSize: '32px', marginBottom: '8px' }}>✅</div>
                    <div>No new enquiries</div>
                  </div>
                ) : (
                  <div>
                    {newEnquiries.map(enq => (
                      <div key={enq.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 20px', borderBottom: '1px solid rgba(255,255,255,0.05)', borderLeft: '3px solid #DC2626' }}>
                        <div>
                          <div style={{ fontSize: '13px', fontWeight: 600, color: 'white' }}>{enq.name}</div>
                          <div style={{ fontSize: '12px', color: '#0066FF', marginTop: '2px' }}>{enq.phone}</div>
                          <div style={{ fontSize: '11px', color: '#475569', marginTop: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '180px' }}>{enq.message}</div>
                        </div>
                        <div style={{ fontSize: '11px', color: '#475569' }}>{formatDate(enq.created_at)}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Low Stock */}
            {lowStock.length > 0 && (
              <div className="widget">
                <div className="widget-header">
                  <h3 style={{ fontFamily: 'Montserrat', fontSize: '15px', fontWeight: 700, color: 'white' }}>
                    ⚠️ Low Stock Alert
                    <span style={{ marginLeft: '8px', background: 'rgba(245,158,11,0.1)', color: '#F59E0B', borderRadius: '50px', padding: '1px 8px', fontSize: '11px' }}>{lowStock.length} products</span>
                  </h3>
                  <Link to="/admin/inventory" style={{ fontSize: '12px', color: '#0066FF', textDecoration: 'none', fontWeight: 600 }}>Manage Stock →</Link>
                </div>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '400px' }}>
                    <thead>
                      <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        {['Product', 'Category', 'Stock', 'Min Stock', 'Status'].map(h => (
                          <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontSize: '11px', color: '#475569', textTransform: 'uppercase', letterSpacing: '1px' }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {lowStock.map(p => (
                        <tr key={p.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                          <td style={{ padding: '10px 16px', fontSize: '13px', fontWeight: 600, color: 'white' }}>{p.name}</td>
                          <td style={{ padding: '10px 16px', fontSize: '12px', color: '#94A3B8' }}>{p.category_name || '-'}</td>
                          <td style={{ padding: '10px 16px', fontSize: '14px', fontWeight: 800, color: p.stock === 0 ? '#DC2626' : '#F59E0B' }}>{p.stock}</td>
                          <td style={{ padding: '10px 16px', fontSize: '12px', color: '#475569' }}>{p.min_stock}</td>
                          <td style={{ padding: '10px 16px' }}>
                            <span style={{ padding: '3px 10px', borderRadius: '50px', fontSize: '11px', fontWeight: 600, background: p.stock === 0 ? 'rgba(220,38,38,0.1)' : 'rgba(245,158,11,0.1)', color: p.stock === 0 ? '#DC2626' : '#F59E0B' }}>
                              {p.stock === 0 ? 'Out of Stock' : 'Low Stock'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
